import React from 'react';
import { NavLogo, NavAccountBlock } from './components';
import styles from './Header.module.scss';
import cn from 'classnames';

interface HeaderProps {
  onToggleAside: () => void;
  isPrivatePage?: boolean;
  isFixedHeader?: boolean;
}

const Header = ({ isPrivatePage, onToggleAside, isFixedHeader }: HeaderProps): JSX.Element => (
  <header className={cn(styles.header, { [styles.fixedHeader]: isFixedHeader })}>
    {isPrivatePage ? (
      <div className={styles.headerPrivateContent}>
        <NavLogo onToggleAside={onToggleAside} isPrivatePage={isPrivatePage} />
        <NavAccountBlock />
      </div>
    ) : (
      <NavLogo isPrivatePage={isPrivatePage} />
    )}
  </header>
);

export default Header;
